import { GETNEW, POSTNEW, DELETENEW, EXPORTNEW, PUTNEW, POSTFormDataImport } from '@/request/http'

// 获取学年学期数据
export const getSchoolSemester = p => GETNEW('/studentv2/calendar/get/school-year-term', p, 4)

// 获取计划分页数据
export const getWNSPlantData = p => POSTNEW('/studentv2/orientation-plan/page', p, 4)

// 计划-计划创建/修改页面获取每个步骤的功能列表接口
export const getOneStepDataList = p => POSTNEW('/studentv2/orientation-plan-config/findByGroupCode', p, 4)

// 计划创建修改
export const welcomeStudentPlantSaveData = p => POSTNEW('/studentv2/orientation-plan/save', p, 4)

// 计划创建修改
export const welcomeStudentChangePlantStatus = p => POSTNEW('/studentv2/orientation-plan/updateStatus', p, 4)

// 根据id获取计划详情
export const idGetWelcomeStudentPlantData = p => GETNEW('/studentv2/orientation-plan/getById', p, 4)

// 迎新日程-分页查询
export const getOrientationScheduleData = p => POSTNEW('/studentv2/orientation-schedule/page', p, 4)

// 迎新日程删除
export const delOrientationScheduleData = p => DELETENEW('/studentv2/orientation-schedule/del', p, 4)

// 迎新日程新增或者修改
export const orientationScheduleDataAddUpdate = p => POSTNEW('/studentv2/orientation-schedule/save', p, 4)

// 根据id获取日程详情
export const idGetOrientationScheduleData = p => GETNEW('/studentv2/orientation-schedule/get', p, 4)

// 获取大屏所有数据（soket）
export const planIdGetScreenData = p => GETNEW('/studentv2/webSocket/orientation-count/{planId}', p, 4)

// 登录后首次进入大屏获取的大屏数据
export const firstGetScreenData = p => GETNEW('/studentv2/orientation-count/monitor-screen-hkj', p, 4)

// 单独获取大屏中入校时间统计
export const aloneGetEnterTimeData = p => GETNEW('/studentv2/orientation-count/findGroupByHour', p, 4)

// 入校时间统计获取数据
export const getEnterSchoolTimeData = p => GETNEW('/studentv2/orientation-count/findGroupByHour', p, 4)

// 以下为迎新详情页面接口
// 获取迎新计划详情页中迎新准备工作各个功能块
export const getWSprepareWorkAllFunctions = p => GETNEW('/studentv2/orientation-function/getFunction/{functionType}', p, 4)

// 获取迎新计划详情页中 迎新人数的统计、完成人数的统计、报到人数的统计、下载登录人数的统计和生日数据图表的数据
export const getWSpeopleStatisticsAndBirthdayChartData = p => GETNEW('/studentv2/orientation-count/findOrientationDetailCount', p, 4)

// 获取迎新计划详情页中 迎新进度统计接口
export const getWSprocessStatisticsChartData = p => GETNEW('/studentv2/orientation-count/findOrientationScheduleCount', p, 4)

// 入校大屏统计页 （学生进入学校时更改学生入校状态）
export const enterUpdateStudentStatus = p => GETNEW('/studentv2/orientation-count/findIntoSchoolScreenCount', p, 4)

// 学生展示二维码 迎新大屏扫码提交接口
export const teacherScanStudentCodesubmitData = p => POSTNEW('/studentv2/orientation-register/save/{registerWay}', p, 4)

// 根据大学id获取planId
export const colleageIdGetPlanId = p => GETNEW('/studentv2/orientation-plan/teacher/get-plan', p, 4)

// 迎新分析页面统计接口
export const wsDataAnalyseStatistics = p => GETNEW('/studentv2/orientation-count/findOrientationAnalysisCount', p, 4)

// 迎新分析页面获取高考接口
export const wsDataAnalyseStatisticsScore = p => GETNEW('/studentv2/orientation-count/findPersonalCeeScoresCount', p, 4)

// 获取迎新进度中的日期列表
export const getProcessDataSearchOptions = p => POSTNEW('/studentv2/calendar/findDayBySchoolYear', p, 4)

// 获取迎新进度动态字段
export const wsGetProcessDynamicFields = p => GETNEW('/studentv2/orientation-register/get-cross-field', p, 4)

// 迎新进度-分页查询
export const wsGetProcessTableData = p => POSTNEW('/studentv2/orientation-register/page-cross', p, 4)

// 计划-获取迎新流程（不区分学生）
export const wsGetProcessNode = p => GETNEW('/studentv2/orientation-register/get/slow', p, 4)

// 计划-进度导出
export const wsGetProcessTableDataExport = p => EXPORTNEW('/studentv2/orientation-register/export-cross', p, 4)

// 计划分析-导出页面数据
export const wsPlanAnalyzeDataExport = p => EXPORTNEW('/studentv2/orientation-count/export-OrientationAnalysis', p, 4)

// 计划分析-导出高考分数数据
export const wsPlanAnalyzeScroeDataExport = p => EXPORTNEW('/studentv2/orientation-count/export-personalCeeScoresCount', p, 4)

// 获取迎新计划中生日数据列表
export const getProcessDataBirthdayData = p => POSTNEW('/studentv2/orientation-count/findBirthdayPage', p, 4)

// 获取迎新计划中生日数据采集
export const getProcessDataBirthday = p => GETNEW('/studentv2/orientation-count/findBirthdayCount', p, 4)

// 获取迎新计划中生日数据导出
export const DataBirthdayExport = p => EXPORTNEW('/studentv2/orientation-count/export-birthday', p, 4)

// 迎新-节点办理记录分页查询
export const wsGetSingleNodeData = p => POSTNEW('/studentv2/orientation-register/page-vertical', p, 4)

// 计划详情-统计图表数据（曹）
export const wsGetChartDataCao = p => POSTNEW('/dataform/stat/dataCount', p, 4)

// 计划详情-军训服装统计图表数据（曹）
export const wsGetChartDataIsGetClothNum = p => POSTNEW('/studentv2/order/isGetClothNum', p, 4)

// 计划详情-一寸照片统计图表数据（曹）
export const wsGetOneInchPhotoNum = p => POSTNEW('/dataform/stat/dataCount', p, 4)

// 大屏获取资讯问题
export const wsGetConsultQuestions = p => GETNEW('/consult/management/all/consult', p, 4)

// 获取迎新环节统计数据
export const wsGetLinkStatisticsData = p => GETNEW('/studentv2/orientation-count/findOrientationNodeCount', p, 4)

// 迎新-节点办理记录分页查询
export const wsGetLinkData = p => POSTNEW('/studentv2/orientation-register/page-vertical', p, 4)

// 迎新-环节分页查询
export const wsGetLinkPageData = p => POSTNEW('/studentv2/orientation-register/page-node', p, 4)

// 获取迎新环节节点数据
export const wsGetLinkNodeData = p => GETNEW('/studentv2/orientation-register/get/node', p, 4)

// 大屏统计-应报到数、已报到，各学院报到情况
export const oldStudentReturnSchoolData = p => GETNEW('/dataform/qrcode-slow/statistics', p, 4)

// 大屏统计-应报到数、已报到，各学院报到情况 新生和老生
export const allStudentReturnSchoolData = p => GETNEW('/dataform/qrcode-slow/statistics-all', p, 4)

// 迎新-节点办理记录分页查询
export const oldStudentSignIn = p => POSTNEW('/dataform/qrcode-slow/sign', p, 4)

// 迎新-详情导出数据
export const plantDetailExportData = p => EXPORTNEW('', p, 4)

// 迎新环节-导出接口
export const welNewDataExport = p => EXPORTNEW('/studentv2/orientation-register/export-node', p, 4)

// 迎新-交通工具
export const transportation = p => GETNEW('/dataform/statistics/transportation', p, 4)

// 获取物品领取扫码人数
export const getItemCollectionNumber = p => POSTNEW('/studentv2/order/getGroupNum', p, 4)

// 物品领取扫码提交
export const submitItemCollection = p => GETNEW('/studentv2/order/collectItems', p, 4)

// 新生院系专业班级级联
export const getNewbornClassTree = p => GETNEW('/studentv2/faculty/tree/fac-maj-preclass', p, 4)

// 新生寝室管理批量修改
export const batchModifyNewbornDorm = p => POSTNEW('/studentv2/prepare/updateByIds', p, 4)

// 新生寝室管理单个修改
export const modifyNewbornDorm = p => POSTNEW('/studentv2/prepare/updateById', p, 4)

// 新生数据/寝室管理表头
export const getNewbornDataTableHead = p => GETNEW('/studentv2/archivesPrepare_config/default/list-field', p, 4)

// 新生寝室管理导入
export const importNewbornDormTable = p => POSTFormDataImport('/studentv2/prepare/importDorm', p, 4)

// 新生数据/寝室管理表格
export const getNewbornDataTableData = p => POSTNEW('/studentv2/prepareArchives/page', p, 4)

// 新生数据/寝室管理导出
export const exportNewbornDataTable = p => EXPORTNEW('/studentv2/prepareArchives/export', p, 4)

// 获取新生数据同步状态
export const getSyncNewbornState = p => GETNEW('/studentv2/prepare/getSynStatus', p, 4)

// 新生数据同步
export const syncNewbornData = p => POSTNEW('/studentv2/prepare/synStudentInfo', p, 4)

// 新生数据管理导入
export const importNewbornDataTable = p => POSTFormDataImport('/studentv2/prepare/importPrepareStudent', p, 4)

// 批量删除新生数据管理
export const delNewbornDataTableData = p => POSTNEW('/studentv2/prepareArchives/deleteByIds', p, 4)

// 批量修改新生数据班级
export const modifyNewbornDataClass = p => POSTNEW('/studentv2/prepare/updateClassList', p, 4)

// 获取新生数据管理详情
export const getNewbornDetailData = p => POSTNEW('/studentv2/prepareArchives/detail', p, 4)

// 提交新生数据管理详情
export const submitNewbornDetailData = p => POSTNEW('/studentv2/prepareArchives/saveOrupdate', p, 4)

// 新生班级管理 一键生成班级
export const submitOneTouchNewbornStudentNo = p => POSTNEW('/studentv2/prepare/oneTouchSaveBatchStudentNoPrepare', p, 4)

// 新生班级管理表格
export const getNewbornClassTableData = p => POSTNEW('/studentv2/classPrepare/pageClassPrepareInfo', p, 4)

// 新生班级管理导出
export const exportNewbornClassTable = p => EXPORTNEW('/studentv2/classPrepare/exportClassPrepareInfoMergeCell', p, 4)

// 新生班级管理修改专业简称
export const changeClassMajorAbbr = p => POSTNEW('/studentv2/major/update', p, 4)

// 新生班级管理管理班级分页
export const getNewbornClassManageTable = p => POSTNEW('/studentv2/classPrepare/pageClassPrepareInfoManage', p, 4)

// 新生班级管理管理班级导入
export const importNewbornClassManageTable = p => POSTFormDataImport('/studentv2/classPrepare/importClassPrepareInfoExcel', p, 4)

// 新生班级管理管理班级导出
export const exportNewbornClassManageTable = p => EXPORTNEW('/studentv2/classPrepare/exportClassPrepareInfo', p, 4)

// 新生班级管理 添加/编辑 班级
export const newbornManageClass = p => POSTNEW('/studentv2/classPrepare/saveOrUpdateClassPrepareInfo', p, 4)

// 新生班级管理 删除 班级
export const newbornManageDelClass = p => POSTNEW('/studentv2/classPrepare/deleteClassPrepareInfoAndTransferStudentById', p, 4)

// 批量修改班主任/辅导员
export const batchModifyClassTeacher = p => POSTNEW('/studentv2/classPrepare/updateBatchClassPrepareInfo', p, 4)

// 新生班级管理 新生数量/未分配数量
export const getNewbornAllocationCount = p => POSTNEW('/studentv2/classPrepare/countClassPrepareInfoManage', p, 4)

// 新生班级管理 一键生成班级
export const submitOneTouchNewbornClass = p => POSTNEW('/studentv2/classPrepare/oneTouchSaveBatchClassPrepare', p, 4)

//  获取学号/班级规则设置
export const getNewbornRuleSetting = p => POSTNEW('/studentv2/prepareDefine/tree', p, 4)

// 获取班主任列表
export const getClassTeacherList = p => POSTNEW('/counselor/counselor-info/listTeacherInfo', p, 4)



// WEBPACK FOOTER //
// ./src/api/modules/welcomeNewStudent.js